import { atom } from 'recoil';
import { CustomerWithOperationsListType } from '../interfaces/Customer';

export const CustomersWithOperationsListState = atom<CustomerWithOperationsListType>({
  key: 'CustomersWithOperationsListState',
  default: {
    list: null,
  },
});
